import Tools from "@/shared/services/tools";
import gCard from "@/components/g-card/g-card.vue";
import gButton from "@/components/g-button/g-button.vue";
import gForm from "@/components/g-form/g-form.vue";
import gPdf from "@/components/g-pdf/g-pdf.vue";
import ReclamacaoTecnicaController from "@/shared/controllers/reclamacaoTecnica/reclamacaoTecnicaController";
import ReclamacaoTecnicaComercialPDF from "./PDF/ReclamacaoTecnicaComercialPDF.vue";

const name = 'DetalhesReclamacaoTecnica'

export default {
  name,

  components: { 
    "g-card": gCard,
    "g-button": gButton,
    "g-form": gForm,
    'g-pdf': gPdf,
    ReclamacaoTecnicaComercialPDF
  }, 

  props: { },

  mounted () { 
    this.GetDetalhesReclamacao()
    this.getLogReclamacaoTecnica()
  },

  updated () { },

  data () {
    return { 
      DetalhesReclamacao: [],
      executarvisualizacao: 0,
      renderiza: false,
      Id:'',
      ReclamacaoTecnicaId: null,
      AcompanhaAmostra: false,
      MascaraCnpj: {}
    }
  },

  methods: {
    gerarPdf(){
      this.executarvisualizacao++
    },
    imprimir()
    {
      
      this.renderiza = true
      this.ReclamacaoTecnicaId = this.$route.params.id
      this.executarvisualizacao++
    },
    retornaTelaReclamacoesTecnicas() {
      this.$router.push(`/reclamacao-tecnica-comercial`)
    },

    getLogReclamacaoTecnica(){
      this.axios ({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `ReclamacaoTecnica/getLogReclamacaoTecnica/`
      })
    },

    GetDetalhesReclamacao() {
      let Id = this.$route.params.id
      this.$isLoading(true)
      ReclamacaoTecnicaController.GetDetalhesReclamacao(Id).requisicao
      .then(response => {
        this.DetalhesReclamacao = response.data.data
        this.AcompanhaAmostra = response.data.data.acompanhaAmostra
        this.MascaraCnpj = Tools.formatarCnpj(response.data.data.cnpj)
      })
      .finally(this.$isLoading(false))
    },
  },

  computed: { }, 

};